<ng-container *ngIf="Address">
  <ion-item class="w50" lines="none">
    <ion-label>Ulica</ion-label>
    <ion-input [class.error-input]="Address.isStreetNameShowValidator" [(ngModel)]="Address.streetName"></ion-input>
    <p *ngIf="Address.isStreetNameShowValidator" class="error"><ion-icon name="close-sharp"></ion-icon></p>
  </ion-item>
  <ion-item class="w25" lines="none">
    <ion-label>Nr domu</ion-label>
    <ion-input [class.error-input]="Address.isStreetNumberShowValidator" [(ngModel)]="Address.streetNumber"></ion-input>
    <p *ngIf="Address.isStreetNumberShowValidator" class="error"><ion-icon name="close-sharp"></ion-icon></p>
  </ion-item>
  <ion-item class="w25" lines="none" *ngIf="Address.showFlatNumber">
    <ion-label>Nr mieszkania</ion-label>
    <ion-input [class.error-input]="Address.isFlatNumberShowValidator" [(ngModel)]="Address.flatNumber"></ion-input>
    <p *ngIf="Address.isFlatNumberShowValidator" class="error"><ion-icon name="close-sharp"></ion-icon></p>
  </ion-item>
  <ion-item lines="none" class="w25">
    <ion-label>Kod pocztowy</ion-label>
    <ion-input [class.error-input]="Address.isPostCodeShowValidator" [(ngModel)]="Address.postCode"></ion-input>
    <p *ngIf="Address.isPostCodeShowValidator" class="error"><ion-icon name="close-sharp"></ion-icon></p>
  </ion-item>
  <ion-item lines="none" class="w75">
    <ion-label>Miejscowość</ion-label>
    <ion-input [class.error-input]="Address.isCityShowValidator" [(ngModel)]="Address.city"></ion-input>
    <p *ngIf="Address.isCityShowValidator" class="error"><ion-icon name="close-sharp"></ion-icon></p>
  </ion-item>
  <ion-item lines="none" class="w50" *ngIf="Address.showWojewodztwo">
    <ion-label>Województwo</ion-label>
    <ion-input [class.error-input]="Address.isWojewodztwoShowValidator" [(ngModel)]="Address.wojewodztwo"></ion-input>
    <p *ngIf="Address.isWojewodztwoShowValidator" class="error"><ion-icon name="close-sharp"></ion-icon></p>
  </ion-item>
  <ion-item lines="none" class="w50" *ngIf="Address.showPowiat">
    <ion-label>Powiat</ion-label>
    <ion-input [class.error-input]="Address.isPowiatShowValidator" [(ngModel)]="Address.powiat"></ion-input>
    <p *ngIf="Address.isPowiatShowValidator" class="error"><ion-icon name="close-sharp"></ion-icon></p>
  </ion-item>
  <ion-item lines="none" class="w50" *ngIf="Address.showPoczta">
    <ion-label>Poczta</ion-label>
    <ion-input [class.error-input]="Address.isPocztaShowValidator" [(ngModel)]="Address.poczta"></ion-input>
    <p *ngIf="Address.isPocztaShowValidator" class="error"><ion-icon name="close-sharp"></ion-icon></p>
  </ion-item>
  <ion-item lines="none" class="w50" *ngIf="Address.showGmina">
    <ion-label>Gmina</ion-label>
    <ion-input [class.error-input]="Address.isGminaShowValidator" [(ngModel)]="Address.gmina"></ion-input>
    <p *ngIf="Address.isGminaShowValidator" class="error"><ion-icon name="close-sharp"></ion-icon></p>
  </ion-item>
</ng-container>
